<template>
  <div class="cpunk_page page_detail">
    <rebuild-nav-bar></rebuild-nav-bar>
    <!--  -->
    <div class="banner-wrapper">
      <swiper class="banner-list" :options="swiperOption" v-if="projectData.picture">
        <swiper-slide class="banner-item" v-for="(item, index) in projectData.picture" :key="index">
          <div class="banner-item-img" :style="{ backgroundImage: 'url(' + hostUrl + item + ')' }"></div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <img src="~@static/funding_cpunk/creation/pic_border.png" class="cover" alt="" />
    </div>
    <!--  -->
    <div class="project-basic">
      <h1 class="project-title">{{ projectData.event_name }}</h1>
      <h2 class="project-sub-title">{{ projectData.event_summary }}</h2>
      <!--  -->
      <div class="project-city"><img src="~@static/funding/icon-pin.png" class="icon" />{{ projectData.city }}</div>
      <div class="project-author project-time" v-if="projectData.plan_status == 1">
        <img class="icon" src="~@static/fundingnew_/icon-time.png" />
        <span class="text">{{ projectData.event_time }}</span>
      </div>
      <div class="project-author"><img src="~@static/funding/icon-author.png" class="icon" />by {{ projectData.username }}</div>
      <div v-if="projectData.type == '1'" class="project-type">
        <div>
          <!-- 联系参与 -->
          <img src="~@static/funding/icon-phone.png" class="icon" v-if="isPhone" />
          <img src="~@static/funding/icon-wechat.png" class="icon" v-else />
          {{ projectData.wechat }}
        </div>
      </div>
      <ul class="project-tags-list">
        <li class="tag-item" v-for="item of projectData.tags" :key="item.id">#{{ item }}</li>
      </ul>
    </div>
    <!--  -->
    <div class="project-desc show">
      <div class="t" v-html="projectData.description"></div>
    </div>
    <!-- 视频 -->
    <div class="video-preview">
      <div class="video-cover" v-if="previewVideoUrl" @click="playVideo">
        <iframe frameborder="0" width="100%" height="100%" :src="previewVideoUrl" allowfullscreen></iframe>
      </div>
    </div>

    <div class="project-input-cell links" v-if="projectData.links && projectData.links.length">
      <div class="item" v-for="(item, index) in projectData.links" :key="index" @click="bindToLink(item.url)">
        <div class="icon">
          <img src="~@static/funding_cpunk/creation/icon-link.png" alt="" />
        </div>
        <div class="bar gradient-bg">{{ item.desc }}</div>
      </div>
    </div>

    <div class="project-input-cell people">
      <div class="item">
        <div class="icon">
          <img src="~@static/funding_cpunk/creation/icon-people.png" alt="" />
        </div>
        <div class="bar gradient-bg">
          <span>夜计划规模</span>
          <span>{{ projectData.number }}人</span>
        </div>
      </div>
    </div>
    <!-- 点赞分享 -->
    <div class="project-status-bar mt20">
      <div class="liked-status">
        <div class="liked-statistics">
          <div class="liked_btn" @click="bindLiked">
            <img src="~@static/funding_cpunk/creation/star.png" />
          </div>
          <div class="liked-operation">
            <span class="beat-num">{{ projectData.total }}</span
            >人已点赞
          </div>
          <div class="like-users">
            <img v-for="(item, index) in projectData.like_users" :key="index" :src="item" />
          </div>
        </div>
        <img src="~@static/funding_cpunk/creation/share.png" class="share-operation" @click="handleShare" />
      </div>
    </div>

    <!-- 评论 -->
    <div class="comments-container">
      <template v-if="commentsList.length">
        <div class="comments-title">
          <img src="~@static/funding_cpunk/creation/title_comment.png" alt="" />
        </div>
        <div class="comments-list">
          <div v-for="(item, index) in commentsList" :key="index" class="comment-list-item">
            <div class="avatar-container">
              <img :src="item.avatar" />
            </div>
            <div class="comment-list-item-wrapper">
              <div class="user-bar">
                <div class="name">{{ item.nickname }}</div>
                <div class="data-time">
                  {{ item.formatTime.year }}.{{ item.formatTime.month }}.{{ item.formatTime.day }} {{ item.formatTime.hours }}:{{ item.formatTime.minutes }}
                </div>
              </div>
              <div class="comment-content">{{ item.comment }}</div>
            </div>
          </div>
        </div>

        <load-more-btn v-if="hasMoreComments" text="查看全部评论+" @loadMore="loadMoreComments"></load-more-btn>
      </template>

      <div v-if="noLogin" class="nologin-tips">
        <div class="tips">登录后才能说</div>
        <div class="create_btn_s1" @click="toLogin"># 登录 #</div>
      </div>

      <div v-else class="comment-submit">
        <div class="input-area">
          <div class="project-desc">
            <div class="comment-placeholer" v-if="comment == '' && !focus" @click.stop.prevent="handleClickTextarea">写下我的评论</div>
            <div class="desc-default">
              <div class="form-input">
                <textarea
                  class="form-control"
                  ref="focusTextarea"
                  @blur.prevent="handleBlurTextarea"
                  @focus.prevent="handleClickTextarea"
                  placeholder=""
                  v-model.trim="comment"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="submit-btn" @click="submitComment">发送</div>
        <div class="create_btn_s1" @click="bindToCreation"># 我也要造一个 #</div>
      </div>
    </div>
    <follow-modal v-if="followModalShow" :data="followModal" @close="followModalClose"></follow-modal>
    <wx-share :show="wxShareShow" :shareTips="shareTips" @close="closeShare"></wx-share>

    <!-- <div class="join-wrapper" v-if="isFromCalendar">
      <template v-if="projectData.status == 2">
        <div class="create_btn_s1"># 活动已结束 #</div>
      </template>
      <template v-else>
        <template v-if="noLogin || is_subscribe == 100">
          <div class="create_btn_s1" @click="bindsubscribe"># 我要参加 #</div>
        </template>
        <template v-if="is_subscribe == 0">
          <div class="create_btn_s1"># 报名审核中 #</div>
        </template>
        <template v-if="is_subscribe == 1">
          <div class="create_btn_s1"># 已报名 #</div>
        </template>
        <template v-if="is_subscribe == 2">
          <div class="create_btn_s1"># 报名未通过 #</div>
        </template>
      </template>
    </div>
    <div class="join-wrapper" v-if="isFromJoin">
      <template v-if="projectData.audit_status == 0">
        <div class="create_btn_s1"># 报名审核中 #</div>
      </template>
      <template v-if="projectData.audit_status == 1">
        <div class="create_btn_s1"># 已报名 #</div>
      </template>
      <template v-if="projectData.audit_status == 2">
        <div class="create_btn_s1"># 报名未通过 #</div>
      </template>
    </div> -->
    <div>
      <img src="~@static/funding_cpunk/creation/ad_pic.png" width="100%" alt="" @click="toRank" />
    </div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import RebuildNavBar from '@components/RebuildNavBar'
import { mapState } from 'vuex'
import { verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'
import WxShare from '@components/WxShare'
import FollowModal from '@components/FollowModal'
import ShareBox from '@components/ShareBox'
import LoadMoreBtn from '@components/LoadMoreBtn'
import StepBtn from '../components/StepBtn'
import ProjectLinks from './components/ProjectLinks'

export default {
  name: '',
  components: {
    RebuildNavBar,
    WxShare,
    FollowModal,
    ShareBox,
    LoadMoreBtn,
    StepBtn,
    ProjectLinks,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      uploadUrl: this.$apiConfig.uploadUrl,
      wxShareShow: false,
      shareTips: '',
      shareData: {},
      showShareBox: false,
      showShareBoxTop: false,
      followModal: {
        title: '',
        subTitle: '',
        isLocalCode: '',
        hasBtn: '',
        btnText: '',
        btnLink: '',
        btnAction: '',
      },
      followModalShow: false,
      projectId: '',
      projectData: {},
      comment: '',
      commentsList: [],
      commentsPage: 1,
      commentsPerPage: 10,
      canComment: true,
      hasMoreComments: true,
      filterParam: {},
      canLoad: true,
      previewVideoUrl: '',
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
        //循环
        loop: true,
        initialSlide: 0,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        //自动播放
        autoplay: {
          delay: 22500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 500,
        //滑动方向
        direction: 'horizontal',
        preventLinksPropagation: false,
      },
      focus: false,
      isBili: false,
      isFromCalendar: false,
      isFromJoin: false,
      is_subscribe: 100, //是否已报名 0审核中 1通过 2拒绝 100未报名
      isShowSubscribe: false,
      subscribeStatus: 4, //3 手机号 4 手机+通知
      hasFinishProfile: false, //已完善个人信息
      isPhone: false,
    }
  },
  computed: {
    ...mapState(['authorization', 'nickname', 'mobile']),
    noLogin() {
      return !this.authorization || this.authorization == ''
    },
  },
  created() {
    let { path_from } = this.$route.query
    if (path_from === 'bili') {
      this.isBili = true
    }
    if (path_from == 'calendar') {
      this.isFromCalendar = true
    }
    if (path_from == 'join') {
      this.isFromJoin = true
    }
    this.addClick = function () {
      this.wxShareShow = false
    }
    window.addEventListener('click', this.addClick, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('click', this.addClick, false)
    })
    if (verify.isPhone(this.projectData.wechat)) {
      this.isPhone = true
    }
  },
  mounted() {
    this.projectId = this.$route.params.id

    //初始化索引
    this.filterParam = {
      page: this.commentsPage,
      'per-page': this.commentsPerPage,
    }

    this.requestProjectDetail()
    this.requestComments()
    this.requestProfile()
    if (this.isFromCalendar) {
      //从日历过来的，查看报名状态
      this.checkStatus()
    }
  },
  methods: {
    handleClickTextarea() {
      this.$refs.focusTextarea.focus()
      this.focus = true
    },
    handleBlurTextarea() {
      this.focus = false
      document.querySelector('#detail').scrollTop += 2
    },
    playVideo() {
      // _jcq.push([
      //   '_track',
      //   'yjhbcvideo_click',
      //   {
      //     title: this.projectData.event_name,
      //   },
      // ])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc9', name: this.projectData.event_name })
    },
    bindToLink(url) {
      if (url) {
        window.location.href = url
      }
      // _jcq.push([
      //   '_track',
      //   'yjhbcurl_click',
      //   {
      //     title: this.projectData.event_name,
      //   },
      // ])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc10', name: this.projectData.event_name })
    },
    requestProjectDetail(type) {
      let url = this.$apiConfig.newPlansUrl
      if (this.isFromCalendar) {
        url = this.$apiConfig.winnerPlanUrl
      }
      if (this.isFromJoin) {
        url = this.$apiConfig.myJoinPlanUrl
      }
      this.$request.get(url + '/' + this.projectId).then(res => {
        let resData = res.data
        if (resData.code == 0) {
          let result = resData.data

          result.like_users.forEach(item => {
            if (item == '' || item.length == 0) {
              item = require('@static/fundingnew/register/avatar-default.png')
              console.log(111)
            }
          })

          if (type == 'like_user') {
            this.projectData.like_users = result.like_users
            return
          }
          this.projectData = result
          this.getVideoVid()

          //创建分享
          if (verify.isWeixin()) {
            let _url = window.location.href
            let shareInfo = {}
            shareInfo = {
              title: '绝对夜计划',
              desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
              imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
            }
            this.WXConfig.wxShowMenu(_url, shareInfo)
          }
        }
      })
    },
    requestComments() {
      this.$request
        .get(this.$apiConfig.newCommentUrl + '/' + this.projectId, {
          params: this.filterParam,
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0) {
            let result = resData.data
            let totalPage = result._meta.pageCount
            if (this.filterParam.page == 1) {
              this.commentsList = []
              this.commentsPage = 1
            }
            if (!!result.items && result.items.length) {
              result.items.forEach(item => {
                item.formatTime = tools.formatDate(item.created_at)
                if (item.avatar == '') {
                  item.avatar = require('@static/fundingnew/register/avatar-default.png')
                }
              })
              this.commentsList = this.commentsList.concat(result.items)
              if (this.filterParam.page == totalPage) {
                this.hasMoreComments = false
              } else if (result.items.length < this.commentsPerPage) {
                this.hasMoreComments = false
              } else {
                this.commentsPage++
                this.filterParam.page = this.commentsPage
                this.hasMoreComments = true
              }
            } else {
              this.hasMoreComments = false
            }
            this.canLoad = true
          }
        })
    },
    submitComment() {
      if (!this.canComment) return
      if (this.comment == '') {
        alert('请输入评论内容')
        return false
      }
      this.canComment = false
      this.requestSubmitComment(this.comment)
      // _jcq.push([
      //   '_track',
      //   'yjhbccomment_send',
      //   {
      //     title: this.projectData.event_name,
      //   },
      // ])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc13', name: this.projectData.event_name })
    },
    requestSubmitComment(comment) {
      this.$request
        .post(this.$apiConfig.newCommentUrl + '/' + this.projectId, {
          comment: comment,
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            this.comment = ''
            this.commentsPage = 1
            this.filterParam.page = this.commentsPage
            this.canComment = true
            this.requestComments()
            alert('发送成功')
          }
        })
    },
    bindLiked() {
      if (this.noLogin) {
        alert('您还未登录，需要登录后可获得完整体验')
        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
      } else {
        this.$request.post(this.$apiConfig.newReplanVoteUrl + '/' + this.projectId).then(res => {
          let resData = res.data
          // _jcq.push([
          //   '_track',
          //   'yjhbclike_click',
          //   {
          //     Campaign: this.projectData.event_name,
          //   },
          // ])
          // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc11', name: this.projectData.event_name })
          if (resData.code == 0) {
            this.projectData.voted = '1'
            this.projectData.total = resData.data.total
            this.requestProjectDetail('like_user')
          } else if (resData.code == 900021 || resData.code == 602) {
            alert('同一活动只能投票3次')
          } else {
            alert('投票失败')
          }
        })
      }
    },
    bindToHome() {
      this.$router.push('/funding')
    },
    bindToExploreCity(e) {
      const { city } = e.currentTarget.dataset
      this.$router.push(`/fundingnew/explore?filterCity=${city}`)
    },
    bindToCreation() {
      if (this.isBili) {
        this.$router.push('/fundingnew/creation?creation_from=bili')
      } else {
        this.$router.push('/fundingnew/creation')
      }
      _jcq.push(['_track', 'yjhbccreate'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc5' })
    },
    loadMoreComments() {
      if (this.hasMoreComments && this.canLoad) {
        this.canLoad = false
        this.requestComments()
      }
    },
    scrollToTop(e) {
      window.scroll(0, 0)
    },
    getVideoVid() {
      let _url = this.projectData.video_link
      // _url = 'https://m.bilibili.com/video/BV14T4y1Z7jp'
      if (_url) {
        let vid = ''
        if (_url.includes('b23.tv')) {
          this.$request.post(this.$apiConfig.videoUrl, { url: _url }).then(res => {
            let resData = res.data
            if (resData.code == 0) {
              let u = resData.data.redirect_url
              let i0 = u.indexOf('?')
              if (i0 != -1) {
                u = u.slice(0, i0)
              }
              let u1 = u.split('/')
              vid = u1[u1.length - 1]
              this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
              return
            }
          })
        }

        if (_url.includes('bilibili')) {
          if (_url.match(/\/$/) != null) {
            _url = _url.slice(0, -1)
          }
          _url = _url.split('/')
          vid = _url[_url.length - 1]
          this.previewVideoUrl = `https://player.bilibili.com/player.html?bvid=${vid}&page=1`
        } else {
          _url = _url.split('/')
          vid = _url[_url.length - 1].split('.')[0]
          this.previewVideoUrl = `https://v.qq.com/txp/iframe/player.html?vid=${vid}&tiny=0&auto=0`
        }
      }
    },
    handleShare() {
      // _jcq.push([
      //   '_track',
      //   'yjhbcshare_click',
      //   {
      //     Campaign: this.projectData.event_name,
      //   },
      // ])
      // behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc12', name: this.projectData.event_name })
      if (verify.isWeixin()) {
        this.shareTips = '<p>分享拉票</p><p>为夜计划助力</p>'
        this.wxShareShow = true
      } else {
        this.showQrCode()
      }
      // 分享排名
      this.$request.post(this.$apiConfig.sharePlan, {
        plan_id: this.projectId,
      })
    },
    closeShare() {
      // if (verify.isWeixin()) {
      //   this.wxShareShow = false
      // }
      this.wxShareShow = false
    },
    showQrCode() {
      this.followModal.title = '分享到微信'
      this.followModal.subTitle = '微信扫码，拉好友一起'
      this.followModal.isLocalCode = false
      this.followModal.hasBtn = false
      this.followModalShow = true
    },
    followModalClose() {
      this.followModalShow = false
      this.followModal.title = ''
      this.followModal.subTitle = ''
      this.followModal.isLocalCode = ''
      this.followModal.hasBtn = ''
      this.followModal.btnText = ''
      this.followModal.btnLink = ''
      this.followModal.btnAction = ''
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },

    bindsubscribe: function () {
      if (this.noLogin) {
        alert('您还未登录，需要登录后可获得完整体验')
        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
        return
      }
      // _jcq.push([
      //   '_track',
      //   'calendarinfo_signup',
      //   {
      //     title: this.projectData.event_name,
      //   },
      // ])
      // behavior({ behavior_code: 'prc_bhv_abs_calendar_bc2' })
      this.isShowSubscribe = true
      this.$request
        .post(this.$apiConfig.planSignUpUrl, {
          plan_id: this.projectId,
          join_status: 1, //1手机 2手机加通知
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            console.log('报名提交')
            this.is_subscribe = 0
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    bindToConfirm: function () {
      this.isShowSubscribe = false
      _jcq.push(['_track', 'calendar_know'])
      behavior({ behavior_code: 'prc_bhv_abs_calendar_bc3' })
    },
    toProfile: function () {
      _jcq.push(['_track', 'calendar_myupdate'])
      behavior({ behavior_code: 'prc_bhv_abs_calendar_bc4' })
      this.$router.push('/fundingnew/my/profile?profile_from=calendar')
      this.setData({
        isShowSubscribe: false,
      })
    },
    requestProfile: function () {
      this.$request
        .post(this.$apiConfig.checkProfileUrl)
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            if (resData.data.status == 1) {
              this.hasFinishProfile = true
            }
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    checkStatus: function () {
      this.$request
        .post(this.$apiConfig.planStatusUrl, {
          plan_id: this.projectId,
        })
        .then(res => {
          let resData = res.data
          if (resData.code == 0 && resData.data) {
            this.is_subscribe = resData.data.audit_status //100 未报名 0 审核中 1通过 2拒绝
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    toRank() {
      if (this.noLogin) {
        alert('您还未登录，需要登录后可获得完整体验')
        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
      } else {
        this.$router.push('/fundingnew/ticket')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.step-wrapper {
  position: relative;
  font-family: 'SourceHanSansCN-Normal';
}

.nologin-tips {
  padding: pxtow(32) 0;
  text-align: center;
}

.nologin-tips .tips {
  margin-bottom: pxtow(12);
  font-weight: 500;
  font-size: pxtow(30);
  color: rgba(255, 255, 255, 0.8);
}

.join-wrapper {
  position: fixed;
  bottom: pxtow(150);
  @include respond-to(iphonex) {
    bottom: pxtow(150+75);
  }
  width: 100%;
  padding: 0 5.3333vw;
  left: 0;
  z-index: 11;
  text-align: center;
  .icon::after {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/project/Detail.vue